export function isError(error: any): error is Error {
  return (
    error instanceof Error ||
    (error instanceof Object && "name" in error && "message" in error)
  );
}
